const firebaseConfig = {
    apiKey: "AIzaSyAGeTWGh2tkYYxnQxfyczj2ytX8krEso44",
    authDomain: "creative-agency-client-c5b20.firebaseapp.com",
    databaseURL: "https://creative-agency-client-c5b20.firebaseio.com",
    projectId: "creative-agency-client-c5b20",
    storageBucket: "creative-agency-client-c5b20.appspot.com",
    messagingSenderId: "33782317456",
    appId: "1:33782317456:web:da20f87757c2f26d663315"
  };
  

  export default firebaseConfig;